<template>
    <ct-modal
        title="Improve information."
        v-if="improveInfoVisible"
        @closed="modalClose"
        class="forgot-modal"
        :class="{'imporve-info_mobile': isMobile}"
        width="480px">
        <div slot="body">
            <ct-form ref="improveForm" :model="improveForm" class="modal-form" :rules="improveRules">
                <ct-form-item :label="$t('user.Username')" prop="username" required>
                    <ct-input autocomplete="off" width="100%" v-model.trim="improveForm.username" maxlength="128" clearable :placeholder="$t('user.UsernamePlaceholder')"></ct-input>
                </ct-form-item>
                <ct-form-item :label="$t('user.Nickname')" prop="nickname" required>
                    <ct-input autocomplete="off" width="100%" v-model.trim="improveForm.nickname" maxlength="128" clearable :placeholder="$t('user.NicknamePlaceholder')"></ct-input>
                </ct-form-item>
                <ct-form-item :label="$t('user.School')" prop="school" required>
                    <ct-input autocomplete="off" width="100%" v-model.trim="improveForm.school" maxlength="128" clearable :placeholder="$t('user.SchoolPlaceholder')"></ct-input>
                </ct-form-item>
                <ct-form-item :label="$t('user.Grade')" prop="grade" required>
                    <!-- <ct-input autocomplete="off" width="100%" v-model.trim="improveForm.grade" maxlength="128" clearable placeholder="enter your grade"></ct-input> -->
                    <ct-select
                        class="my-select"
                        autocomplete="off"
                        width="100%"
                        v-model.trim="improveForm.grade"
                        :selectData="gradeList"
                        :method="'click'"
                        :defaultText="$t('user.GradePlaceholder')"
                        clearable></ct-select>
                </ct-form-item>
            </ct-form>
        </div>
        <div slot="footer">
            <ct-button type="primary"
            :disabled="improveValiStatus"
            :isLoading="improveLoading"
            @click.prevent="submitImproveInfo('improveForm')">{{ $t('common.Submit') }}</ct-button>
        </div>
    </ct-modal>
</template>

<script>
import { GRADE } from '@/constants'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    visible () {
      this.improveInfoVisible = this.visible
      this.improveForm = this.formInfo || {
        // email: '',
        // mobile: '',
        school: '',
        grade: '',
        // 英文名
        nickname: '',
        // 中文名
        username: '',
        signature: ''
      }
    }
  },
  data () {
    return {
      improveLoading: false,
      improveValiStatus: false,
      improveInfoVisible: false,
      improveForm: {
        // email: '',
        // mobile: '',
        school: '',
        grade: '',
        // 英文名
        nickname: '',
        // 中文名
        username: '',
        signature: ''
      },
      improveRules: {
      },
      isMobile: window.innerWidth < 768
    }
  },
  computed: {
    gradeList () {
      return JSON.parse(JSON.stringify(GRADE)).map(item => {
        return {
          tag: item.label,
          value: item.value

        }
      })
    }
  },
  methods: {
    modalClose () {
      this.$emit('close')
      this.improveInfoVisible = false
    },
    selfToast (message, type = '') {
      this.$toast({
        message,
        type
      })
    },
    // 完善信息表单提交
    submitImproveInfo (name) {
      if (this.improveLoading) {
        this.selfToast(this.$t('auth.SendTwice'), 'warning')
        return
      }
      this.improveLoading = true
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http.post('/user/update', {
            ...this.improveForm
          }).then(res => {
            const data = res.data
            if (data.code === 1) {
              this.$emit('success')
              // 成功
            } else {
              // 其他所有错误
              this.selfToast(this.$t('common.ErrAgain'), 'error')
            }
            this.improveLoading = false
          }).catch(e => {
            this.selfToast(this.$t('common.ErrAgain'), 'error')
            this.improveLoading = false
          })
        } else {
          this.improveLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/ .my-select {
    width: 200px;
    .ct-select-input {
        line-height: 48px;
        border: 1px solid rgba(26,61,94,.16);
        padding: 0 24px;
        &::placeholder {
            color: rgba(118,139,158,0.5);
            font-size: 14px;
        }
        &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
            color: rgba(118,139,158,0.5);
            font-size: 14px;
        }
        &::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: rgba(118,139,158,0.5);
            font-size: 14px;
        }
        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: rgba(118,139,158,0.5);
            font-size: 14px;
        }
        &:-moz-placeholder { /* Old Mozilla Firefox versions (pre FF19) */
            color: rgba(118,139,158,0.5);
            font-size: 14px;
        }
    }
    .ct-select-box {
        bottom: 100%;
        top: unset!important;
    }
    .ct-select-box::-webkit-scrollbar {
        background-color: #f1f5fc;
        width: 4px;
        height: 4px;
        background-clip: padding-box;
    }
    .ct-select-box::-webkit-scrollbar-button {
        display: none;
        background-color: #2c3e50;
    }
    .ct-select-box::-webkit-scrollbar-thumb {
        background-color: #a1a8af;
        border-radius: 2px;
    }
    .ct-select-box::-webkit-scrollbar-corner {
        background-color: #2c3e50;
    }

}
.imporve-info_mobile /deep/{
.ct-modal--box {
    width: 96%!important;
    min-width: unset !important;;
}
}
</style>
